import { render, staticRenderFns } from "./IconZones.vue?vue&type=template&id=87b46dec"
import script from "./IconZones.vue?vue&type=script&lang=js"
export * from "./IconZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports